import { Component, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { HttpErrorResponse } from '@angular/common/http';
import { User, UserAdapter } from '../../models/user';
import { UsersService } from '../../services/users.service';
import { ToastService } from '../../services/toast.service';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-account',
  standalone: true,
  imports: [FormsModule, TranslatePipe, RouterModule],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent implements OnInit {
  
  user: User = {
    public_id: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    createdAt: new Date(),
    updatedAt: null,
    languageCode: 'en-US',
  };

  // var to store the initial state of the user
  initialUser: User | null = null;

  // available languages
  availableLanguages = [
    { code: 'fr-FR', name: 'Français', flag: 'fr-FR.png' },
    { code: 'en-US', name: 'English', flag: 'en-US.png' }
  ];

  constructor(
    private translate: TranslateService,
    private usersService: UsersService,
    private userAdapter: UserAdapter,
    private toastService: ToastService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.usersService.getCurrentUser().subscribe({
      next: (userFromApi) => {
        if(userFromApi) {
          this.user = this.userAdapter.adapt(userFromApi); 
          this.initialUser = { ...this.user }; // save intial state in case of cancel
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error('Error fetching user data during acocutn initialization 2', err);
      }
    });
  }

  saveChanges() {
    this.usersService.updateCurrentUser(this.userAdapter.adaptToApi(this.user)).subscribe({
      next: (updatedUser) => {
        if(updatedUser) {
          this.user = this.userAdapter.adapt(updatedUser);
          //backup initial state in case of cancel
          this.initialUser = { ...this.user };
          // Changez la langue et attendez que la nouvelle langue soit chargée
          this.translate.use(this.user.languageCode).subscribe(() => {
            // Mettez à jour le localStorage après le changement de langue
            localStorage.setItem('lang', this.user.languageCode);
            // Passez la clé de traduction directement au service toast
            this.toastService.showSuccess('COMMON.UPDATE_SUCCESS');
            window.location.reload();
          });
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error('Error during user information update', err);
        this.toastService.showError('COMMON.UPDATE_ERROR');
      }
    });
  }

  cancelChanges() {
    if (this.initialUser) {
      this.user = { ...this.initialUser };
      this.translate.use(this.user.languageCode);
      this.router.navigate(['/']); // Force refresh of the current route
    }
  }
}
